import { getGlobal } from '@Utils/Globals';
import { ServerPaths } from '@Utils/Paths';
import { DashboardStructs } from '@ModelViews/ModelViews';
import { UserManager } from '@Utils/UserManager';
import _ from 'lodash';
import { urlEncode } from '@Utils/Utils';
// ------------------------------------------------------------------------------------------------
export class BoardLoader {
    // --------------------------------------------------------------------------------------------
    private static _instances: BoardLoader = null;
    public static GetInstance(): BoardLoader {
        if (this._instances == null)
            this._instances = new BoardLoader();
        return this._instances;
    }
    // --------------------------------------------------------------------------------------------
    private serverAddress: string;
    // --------------------------------------------------------------------------------------------
    constructor() {
        // Read the server addess
        let address = getGlobal("YodiBoardServerAddress");
        if (address != null)
            this.serverAddress = address;
        else
            this.serverAddress = "";
    }
    // --------------------------------------------------------------------------------------------
    public async LoadBoard(id: string, isEditable: boolean): Promise<DashboardStructs.YodiBoardLoadResp> {
        let req: DashboardStructs.YodiBoardLoadReq = {
            Id: id,
            IsViewMode: !isEditable
        };

        let headers = { "Content-Type": "application/json" };
        let queryParameters = "?" + urlEncode(req);
        if (process.env.GLOW_BUILD) {
            headers["Authorization"] = "Bearer " + UserManager.GetInstance()?.getAccessToken();
        }

        var resp = await fetch(
            `${this.serverAddress}${ServerPaths["LoadYodiBoards"].Path}${queryParameters}`,
            {
                method: ServerPaths["LoadYodiBoards"].Method,
                mode: 'cors',
                cache: "no-cache",
                credentials: "include",
                headers: headers
            });

        return await resp.json();
    }
    // --------------------------------------------------------------------------------------------

}